import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Search, CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui-kit/button';

export const HeroSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');

  const handleSearch = () => {
    const trimmed = query.trim();
    if (trimmed) {
      navigate(`/templates?q=${encodeURIComponent(trimmed)}`);
    } else {
      navigate('/templates');
    }
  };

  return (
    <section
      className="relative flex flex-col items-center justify-center bg-[#f4f7fa] bg-[url('/hero-bg.png')] bg-cover bg-center px-6 py-20 text-center sm:px-10 sm:py-28 lg:py-36"
    >
      <div className="mx-auto max-w-4xl">
        {/* Heading */}
        <h1 className="text-balance text-4xl font-bold tracking-tight font-aptos sm:text-5xl lg:text-6xl">
          <span className="text-eerie-black">{t('LANDING_HERO_TITLE_LINE1')}</span>
          <br />
          <span className="text-selise-blue">{t('LANDING_HERO_TITLE_LINE2')}</span>
        </h1>

        {/* Subtitle */}
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-globe-grey font-open-sans sm:text-xl">
          {t('LANDING_HERO_SUBTITLE')}
        </p>

        {/* Search bar */}
        <form
          role="search"
          className="mx-auto mt-10 max-w-xl"
          onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
          }}
        >
          <div className="flex flex-col sm:flex-row items-center rounded-full border border-border bg-white shadow-md transition-shadow focus-within:shadow-lg focus-within:ring-1 focus-within:ring-selise-blue/20">
            <div className="flex flex-1 items-center gap-3 px-5 py-3 w-full">
              <Search className="h-5 w-5 shrink-0 text-globe-grey" aria-hidden="true" />
              <input
                type="search"
                aria-label={t('LANDING_SEARCH_PLACEHOLDER')}
                placeholder={t('LANDING_SEARCH_PLACEHOLDER')}
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="w-full bg-transparent text-base text-eerie-black placeholder:text-globe-grey/70 outline-none font-open-sans"
              />
            </div>
            <div className="px-2 pb-2 pt-0 w-full sm:w-auto sm:py-0 sm:pr-2">
              <Button
                type="submit"
                className="w-full sm:w-auto bg-selise-blue hover:bg-[#247EC1] text-white rounded-full px-6 transition-colors"
              >
                {t('LANDING_SEARCH_BUTTON')}
              </Button>
            </div>
          </div>
        </form>

        {/* Trust badges */}
        <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:justify-center sm:gap-8">
          {[
            'LANDING_TRUST_ATTORNEY',
            'LANDING_TRUST_COMPLIANT',
            'LANDING_TRUST_SECURE',
          ].map((key) => (
            <div key={key} className="flex items-center gap-2">
              <CheckCircle2 className="h-[18px] w-[18px] text-selise-blue" />
              <span className="text-sm text-globe-grey font-open-sans">
                {t(key)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
